import { CmsTitleGroup } from '@/cms/components/blocks/shared/cms-title-group';
import type { WorkspaceStudioRenderModel } from '../contracts/server-model';

export function WorkspaceHeroCopy({
  hero,
}: {
  hero: WorkspaceStudioRenderModel['shell']['hero'];
}) {
  return (
    <div
      className="cms-block-workspace-workspace-1-workspace-showcase-layout__workspaceCopy"
      data-cms-workspace-hero-copy=""
    >
      <CmsTitleGroup
        eyebrow={hero.eyebrow}
        title={hero.title}
        align="center"
        as="h1"
        size="hero"
        titleClassName="cms-block-workspace-workspace-1-workspace-showcase-layout__workspaceTitle"
      />
      {hero.subtitle ? (
        <p className="cms-block-workspace-workspace-1-workspace-showcase-layout__workspaceSubtitle">
          {hero.subtitle}
        </p>
      ) : null}
    </div>
  );
}
